import { render, staticRenderFns } from "./CampaignListItemBookingListItem.vue?vue&type=template&id=6c88078a&scoped=true"
import script from "./CampaignListItemBookingListItem.vue?vue&type=script&lang=js"
export * from "./CampaignListItemBookingListItem.vue?vue&type=script&lang=js"
import style0 from "./CampaignListItemBookingListItem.vue?vue&type=style&index=0&id=6c88078a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c88078a",
  null
  
)

export default component.exports